export default __webpack_public_path__ + "static/media/KOD0035-min.c3205491.webp";